export interface UsCity {
  id: number | null
  name: string
  state: string | null
  stateCode: string | null
}

export interface UsState {
  name: string
  state: string
  stateCode: string
}

export function formatCityLabel(city: UsCity | null | undefined): string {
  if (!city?.name) return ""
  if (city.stateCode) return `${city.name}, ${city.stateCode}`
  return city.name
}

export function formatStateLabel(state: UsState | null | undefined): string {
  if (!state?.name) return ""
  if (state.stateCode) return `${state.name} (${state.stateCode})`
  return state.name
}

export function titleCaseCityName(name: string): string {
  return (name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ")
}

export function cityMatchesQuery(city: UsCity, query: string): boolean {
  const q = query.trim().toLowerCase()
  if (!q) return true
  const label = formatCityLabel(city).toLowerCase()
  return label.includes(q) || city.name.toLowerCase().includes(q)
}

export function formatCoverageCitiesLabel(cities: UsCity[] | null | undefined): string {
  if (!cities?.length) return ""
  return cities
    .map((city) => formatCityLabel(city))
    .sort((a, b) => a.localeCompare(b))
    .join(", ")
}
